import React from 'react';

const OurApproach = () => {
  const approaches = [
    {
      icon: "fas fa-balance-scale",
      title: "Independent, Standards-Driven Solutions",
      description: "Our recommendations are based solely on industry best practices and international standards, ensuring unbiased and effective safety solutions."
    },
    {
      icon: "fas fa-tools",
      title: "Practical, Auditable Safety Methods",
      description: "We implement safety measures that are not only compliant but also practical for your operations team to maintain and audit."
    },
    {
      icon: "fas fa-globe-americas",
      title: "Proven Experience in Global Projects",
      description: "Our portfolio spans continents, bringing worldwide expertise and local understanding to every project we undertake."
    }
  ];

  return (
    <section className="min-h-screen flex items-center py-20 px-4 sm:px-6 lg:px-8 bg-gray-50">
      <div className="max-w-7xl mx-auto w-full">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Our Approach</h2>
          <p className="text-xl text-gray-600">Methodology that delivers results</p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {approaches.map((approach, index) => (
            <div key={index} className="bg-white p-8 rounded-lg shadow-lg hover:shadow-xl transition-shadow">
              <i className={`${approach.icon} text-4xl text-blue-600 mb-6 block`}></i>
              <h3 className="text-xl font-bold text-gray-900 mb-4">{approach.title}</h3>
              <p className="text-gray-600 leading-relaxed">{approach.description}</p>
            </div>
          ))}
        </div>
        
        <div className="relative">
          <img
            src="/assets/asset-16.jpg"
            alt="Engineers at work"
            className="w-full rounded-lg shadow-xl"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-gray-900/40 to-transparent rounded-lg"></div>
        </div>
      </div>
    </section>
  );
};

export default OurApproach;
